<template>
    <div id='box'>
        <footer class="footer">
      <div class="footer-inner container">
        <div class="footer-top">
            <div class="footer-top-title">{{ i18n[lang].provide1 }}<span style="color:#e60013;">{{ i18n[lang].provide2 }}</span> {{ i18n[lang].provide3 }}</div>


          <img src="/imgs/home/images/footer-logo_03.png" alt="" />

        </div>
        <div class="footer-bottom">
            <dl class="footer-list">
              <div class="footer-col">
                <router-link to="/goin"><dt>{{ i18n[lang].about }}</dt></router-link>

                <!-- <dd><router-link to="/goin">发展历程</router-link></dd>
                <dd><router-link to="/goin">荣誉资质</router-link></dd>
                <dd><router-link to="/goin">企业文化</router-link></dd> -->
              </div>
              <div class="footer-col">
                <router-link to="/goin"><dt>{{ i18n[lang].services }}</dt></router-link>

                <!-- <dd><router-link to="/goin">俄罗斯</router-link></dd>
                <dd><router-link to="/goin">中亚</router-link></dd>
                <dd><router-link to="/goin">北美</router-link></dd>
                <dd><router-link to="/goin">南美</router-link></dd>
                <dd><router-link to="/goin">中东</router-link></dd> -->
              </div>
              <div class="footer-col">
                <router-link to="/news"><dt>{{ i18n[lang].news }}</dt></router-link>

                <!-- <dd><router-link to="/news">企业介绍</router-link></dd>
                <dd><router-link to="/news">企业新闻</router-link></dd>
                <dd><router-link to="/news">人才招聘</router-link></dd> -->
              </div>
              <div class="footer-col">
                <router-link to="/contact"><dt>{{ i18n[lang].contact }}</dt></router-link>

                <!-- <dd><router-link to="/contact">资料下载</router-link></dd> -->
              </div>
              <div class="footer-col footer-phone">
                <img src="/imgs/home/images/footer-phone_03.png" alt="">
                <span>400 0000 1010</span>
              </div>
            </dl>
            <hr style="width: 100%; margin: 40px auto;">
            <div class="footer-right">
                <img src="/imgs/home/images/weixin_03.png" alt="">
                <img src="/imgs/home/images/shipinhao_03.png" alt="">
                <img src="/imgs/home/images/douyin_03.png" alt="">
                <img src="/imgs/home/images/bzhan_03.png" alt="">
            </div>

        </div>

      </div>
    </footer>
        
    </div>
</template>

<script>
export default {
    components: {
        
    },
    data () {
        return {
          lang: 'CN',
      i18n: {
        CN: {
          home: '首页',
          about: '关于同升',
          services: '产品与服务',
          news: '公司动态',
          contact: '联系我们',
          provide1: '为全球客户提供',
          provide2: '专业安规测试',
          provide3: '解决方案',

        },
        EN: {
          home: 'HOME',
          about: 'ABOUT US',
          services: 'PRODUCT AND SERVICE',
          news: 'NEWS',
          contact: 'CONTACT US',
          provide1: 'Provide professional',
          provide2: 'regulatory testing',
          provide3: 'solutions to global customers',
        },
        RU: {
          home: 'Главная страница',
          about: 'О компании Tongsheng',
          services: 'Продукция и услуги',
          news: 'Новости компании',
          contact: 'Свяжитесь с нами',
          provide1: 'Предоставляем профессиональные',
          provide2: 'тесты регулирования',
          provide3: 'решения для глобальных клиентов',

        }
      }
        }
    },
    created () {
    const saved = localStorage.getItem('lang')
    if (saved) this.lang = saved
  },
    mounted() {
        
    },
    methods: {
        
    },
}
</script>

<style scoped>
.footer {
  min-height: 420px;
  background-image: url(/public/imgs/home/images/footer-bg_02.png);
  background-size: cover;
  background-position: center;

  font-size: 1.3rem;
  color: #000000;
  font-family: "HarmonyOS_Sans_SC_Light";

  position: relative;
}

/* 底部整体布局 */
.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 80px 20px 40px;
}

/* 顶部区域 */
.footer-top {
  width: 95%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}
.footer-top-title {
  font-size: 2.5rem;
  margin-bottom: 20px;
  font-weight:550;
}

/* 底部四列 */
.footer-bottom {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.footer-list {
    width: 100%;
  display: flex;
  align-items: flex-start;

  margin: 0;
}
.footer-col {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
}
.footer-col dt {
  font-weight: bold;
  margin-bottom: 16px;
  color: #000;
}
.footer-col dd {
  margin: 0 0 8px 0;
  line-height: 1.6;
}
.footer-col dd a {
    font-size: 1.1rem;
  color: #454545;
  text-decoration: none;
}
.footer-phone {
  display: flex;
  align-items: center;
}
.footer-phone img {
  margin-right: 10px;
}
.footer-phone span {
  font-size: 1.8rem;
  font-weight: 600;
  color:#e60013;
}
.footer-right {
    width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.footer-right img {
  margin: 0 10px;
}

/* 移动端隐藏 footer */
@media (max-width: 768px) {
  .footer {
    display: none;
  }
}

</style>